"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.BBCodeParser = void 0;
var BBCodeParser_1 = require("./BBCodeParser");
Object.defineProperty(exports, "BBCodeParser", { enumerable: true, get: function () { return BBCodeParser_1.BBCodeParser; } });
var Tag_1 = require("./Tag");
Object.defineProperty(exports, "Tag", { enumerable: true, get: function () { return Tag_1.Tag; } });
